import { Controller } from 'react-hook-form';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { AboutFormControlProps } from '../../types';
import { validateYear } from '../../general/components/constructionYearField';
import { ServiceRadio } from '../components/serviceRadio';
import { YearNumberField } from '../../general/components/yearNumberField';

export const Punktoppvarming: FC<AboutFormControlProps> = ({ control }) => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Controller
        name="oppvarming.oppvarmingVarmepumpe.punktoppvarming.installasjonsAr"
        control={control}
        rules={{
          validate: (value, formValues) => {
            if (!value) {
              return t('register.errorMessage.field.varmepumpePunktInstallasjonsAr');
            }

            return validateYear(value, formValues);
          }
        }}
        render={({ field, fieldState }) => (
          <YearNumberField
            error={fieldState.error}
            value={field.value}
            onChange={(year) => field.onChange(year)}
            informationKey="register.tekniskUtstyr.punktoppvarming.installasjonsAr.information"
            required
          />
        )}
      />

      <Controller
        control={control}
        rules={{
          required: t('required')
        }}
        name="oppvarming.oppvarmingVarmepumpe.punktoppvarming.serviceGjennomfortSiste2Ar"
        render={({ field: { value, onChange }, fieldState }) => (
          <ServiceRadio
            i18nPrefix="register.tekniskUtstyr.punktoppvarming.serviceGjennomfortSiste2Ar"
            value={value}
            onChange={(val) => onChange(val)}
            error={fieldState.error}
          />
        )}
      />
    </Fragment>
  );
};
